import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, unref as _unref } from "vue"

const _hoisted_1 = ["data-test"]
const _hoisted_2 = {
  key: 0,
  class: "pp-draw-numbers__draw-title",
  "data-test": "row-title"
}
const _hoisted_3 = ["data-test"]
const _hoisted_4 = {
  key: 0,
  class: "pp-draw-numbers__number pp-draw-numbers__number--extra",
  "data-test": "number-extra"
}
const _hoisted_5 = { class: "pp-draw-numbers__crown-wrapper" }
const _hoisted_6 = { class: "pp-draw-numbers__number" }
const _hoisted_7 = {
  key: 1,
  class: "pp-draw-numbers__combinations"
}
const _hoisted_8 = { class: "pp-draw-numbers__combinations-column" }
const _hoisted_9 = { class: "pp-draw-numbers__combinations-number" }
const _hoisted_10 = { class: "pp-draw-numbers__combinations-column" }
const _hoisted_11 = ["innerHTML"]
const _hoisted_12 = { class: "pp-draw-numbers__draw-title" }
const _hoisted_13 = {
  class: "pp-draw-numbers__num-row",
  "data-test": "row-addon"
}

import { Lottery } from "@sazka/lotteries/js/models/lottery";
import { LotteryParser } from "@sazka/lotteries/js/utils/lottery-parser";
import { DrawNumbers } from "@/lotteries/services/model/draw-numbers";
import PpDrawNumbersCrown from "./pp-draw-numbers-crown.vue";
import DsDivider from "@sazka/design-system/src/divider/ds-divider.vue";
import { KamenyUtils } from "@sazka/lotteries/js/utils/kameny-utils";


export default /*@__PURE__*/_defineComponent({
  __name: 'pp-draw-numbers',
  props: {
    lottery: {},
    numbers: {},
    sortByDraw: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;

const addonName = LotteryParser.addonDisplayName(props.lottery);

const getDrawLabel = (setIndex, drumIndex) => {
    return LotteryParser.getDrawLabel(props.lottery, props.lottery === Lottery.sportka ? setIndex : drumIndex);
};

const getNumbers = (numbers: number[]) => {
    if (props.sortByDraw) {
        return numbers;
    }

    return numbers.toSorted((a, b) => a - b);
};

const getCombinations = (combinations: number[]): string => {
    if (combinations.length < 1) return "-";
    const mapped = KamenyUtils.mapKamenyNumbers(combinations);
    return mapped.figures.map((x) => x.text).join(", ");
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "pp-draw-numbers",
    "data-test": `results-${_ctx.sortByDraw ? 'ordered' : 'regular'}`
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.numbers?.mainGameNumbers, (setNumbers, setIndex) => {
      return (_openBlock(), _createElementBlock(_Fragment, { key: setIndex }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(setNumbers.drawingDrums, (drum, drumIndex) => {
          return (_openBlock(), _createElementBlock(_Fragment, { key: drumIndex }, [
            (getDrawLabel(setIndex, drumIndex))
              ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(getDrawLabel(setIndex, drumIndex)), 1))
              : _createCommentVNode("", true),
            _createElementVNode("ul", {
              class: "pp-draw-numbers__num-row",
              "data-test": drumIndex === 0 ? 'row-primary' : 'row-additional'
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getNumbers(drum), (num, index) => {
                return (_openBlock(), _createElementBlock("li", {
                  class: "pp-draw-numbers__number",
                  "data-test": "number",
                  key: index
                }, _toDisplayString(num), 1))
              }), 128)),
              (setNumbers.extraNumber)
                ? (_openBlock(), _createElementBlock("li", _hoisted_4, _toDisplayString(setNumbers.extraNumber), 1))
                : _createCommentVNode("", true)
            ], 8, _hoisted_3)
          ], 64))
        }), 128)),
        (setNumbers.kingsNumber)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _cache[0] || (_cache[0] = _createElementVNode("span", { class: "pp-draw-numbers__draw-title" }, "Královské číslo", -1)),
              _createElementVNode("div", _hoisted_5, [
                _createVNode(PpDrawNumbersCrown, { class: "pp-draw-numbers__crown" }),
                _createElementVNode("span", _hoisted_6, _toDisplayString(setNumbers.kingsNumber), 1)
              ])
            ], 64))
          : _createCommentVNode("", true),
        (_ctx.lottery == _unref(Lottery).kameny)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _cache[1] || (_cache[1] = _createElementVNode("span", { class: "pp-draw-numbers__combinations-title" }, "Číslo", -1)),
                _createElementVNode("span", _hoisted_9, _toDisplayString(setNumbers.sumNumber), 1)
              ]),
              _createVNode(DsDivider, { "is-vertical": true }),
              _createElementVNode("div", _hoisted_10, [
                _cache[2] || (_cache[2] = _createElementVNode("span", { class: "pp-draw-numbers__combinations-title" }, "Kombinace čísel", -1)),
                _createElementVNode("span", {
                  class: "pp-draw-numbers__combinations-number",
                  innerHTML: getCombinations(setNumbers.combinations)
                }, null, 8, _hoisted_11)
              ])
            ]))
          : _createCommentVNode("", true)
      ], 64))
    }), 128)),
    (_ctx.numbers.addonNumbers)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("span", _hoisted_12, _toDisplayString(_unref(addonName)), 1),
          _createElementVNode("ul", _hoisted_13, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.numbers.addonNumbers, (num, index) => {
              return (_openBlock(), _createElementBlock("li", {
                class: "pp-draw-numbers__number",
                key: index
              }, _toDisplayString(num), 1))
            }), 128))
          ])
        ], 64))
      : _createCommentVNode("", true)
  ], 8, _hoisted_1))
}
}

})